const DesignFacade = require('../../../facade/design/design');
const ImageSetter = require('../../../facade/design/setters/image');
const ImagesFactory = require('../../images');

module.exports = {
  maxAttempts: 10,
  attemptDelayInMs: 500,

  getNewItem: function (data) {
    const deferred = $.Deferred();
    this.resolveAttempt(data, deferred);
    return deferred.promise();
  },

  isSameModel: function (model1, model2) {
    let url1 = ImagesFactory.getOriginalUrl(model1.source);
    let url2 = ImagesFactory.getOriginalUrl(model2.source);

    url1 = INKIVE.Helpers.getCORSSecureUrl(url1);
    url2 = INKIVE.Helpers.getCORSSecureUrl(url2);

    return url1 === url2;
  },

  resolveAttempt: function (data, deferred, attempt) {
    attempt = attempt || 1;

    if (ImageSetter.prototype.isExternal(data)) {
      attempt === 1 && this.addExternalImageLoadingHint();
      attempt < this.maxAttempts
        ? processNewAttempt.call(this)
        : deferred.reject(new Error('Image loading failed'));
    } else {
      deferred.resolve({ type: 1, source: data.source.url });
    }

    function processNewAttempt () {
      this.waitForExternalImage(attempt).then(_.bind(function () {
        this.resolveAttempt(DesignFacade.get(data.id), deferred, attempt + 1);
      }, this));
    }
  },

  addExternalImageLoadingHint: function () {
    $('.modalWrapper .modal.alert').find('p').append(
      '<br/><b style="font-weight: 400">' +
      INKIVE.TranslateHelper.translate('advice.content.uploading_images_save') +
      '</b>'
    );
  },

  waitForExternalImage: function (attempt) {
    const deferred = $.Deferred();
    _.defer(deferred.resolve, attempt * this.attemptDelayInMs);
    return deferred.promise();
  }
};
